import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const Card = ({ children, className, title, action, variant = 'default' }) => {
  const variants = {
    default: 'bg-white border-border',
    ghost: 'bg-transparent border-transparent',
    elevated: 'bg-white border-border shadow-md'
  };

  return (
    <div className={twMerge(
      clsx(
        "rounded-lg border transition-all",
        variants[variant],
        className
      )
    )}>
      {(title || action) && (
        <div className="flex justify-between items-center px-6 py-4 border-b border-border">
          {title && (
            <h3 className="text-sm font-semibold text-foreground tracking-tight">
              {title}
            </h3>
          )}
          {action && <div>{action}</div>}
        </div>
      )}
      <div className={clsx(title || action ? 'p-6' : 'p-6')}>
        {children}
      </div>
    </div>
  );
};